import { ExternalLink, MessageCircle } from "lucide-react";
import { contactWhatsApp, NEW_TAB } from "@/lib/whatsappLinks";

/** "Open in WhatsApp" for one visible contact. A plain link: opens only on the user's click, sends nothing, records nothing. */
export function OpenInWhatsApp({ contact, testid = "contact-open-whatsapp" }) {
  const s = contactWhatsApp(contact);
  if (!s.ok) {
    return (
      <span role="link" aria-disabled="true" title={s.reason} className="inline-flex max-w-[15rem] cursor-not-allowed flex-col items-start gap-0.5 rounded border border-dashed px-2 py-0.5 text-[11px] text-slate-400" data-testid={`${testid}-disabled`}>
        <span className="inline-flex items-center gap-1 whitespace-nowrap"><MessageCircle className="h-3 w-3" />Open in WhatsApp</span>
        <span className="whitespace-normal text-[10px] leading-snug text-amber-700" data-testid={`${testid}-reason`}>{s.reason}</span>
      </span>
    );
  }
  return (
    <a href={s.url} {...NEW_TAB} className="inline-flex items-center gap-1 rounded border border-emerald-200 px-2 py-0.5 text-[11px] text-emerald-800 hover:bg-emerald-50" data-testid={testid}
       title={s.note}>
      <MessageCircle className="h-3 w-3" />Open in WhatsApp<ExternalLink className="h-3 w-3" aria-hidden="true" /><span className="sr-only"> (opens in a new tab)</span>
    </a>
  );
}
